import React from 'react';

import {
  ContainerBox
} from 'iron-forge-react-modules';
import {
  Box,
  styled
} from '@mui/material';
import {
  AuthRedirector,
  routeDirectory
} from 'modules';



const ChildBox = styled(Box)({
  minHeight: '100vh'
});



export interface IProps {
  children: React.ReactNode | React.ReactNode[];
  disableAuthRedirector?: boolean;
  onlyAllowLoggedOutUsers?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const elContent = props.children;



  return (
    <>
      <ContainerBox.FC disableDefaultMargins>
        <ChildBox>
          {!props.disableAuthRedirector ? (
            <AuthRedirector.FC
              type={props.onlyAllowLoggedOutUsers ? 'onlyAllowLoggedOutUsers' : 'onlyAllowLoggedInUsers'}
              redirectLoggedInUserToRoute={routeDirectory.root.path()}>
              {elContent}
            </AuthRedirector.FC>
          ) : elContent}
        </ChildBox>
      </ContainerBox.FC>

      {/* {!isProd && (
        <Box sx={{
          position: 'fixed',
          left: 64,
          right: 0,
          top: 0,
          zIndex: 10000000,
          opacity: 0.75,
          pointerEvents: 'none'
        }}>
          <TestModeWarningBar.FC styleOptions={{
            backgroundColor: '#FE019A'
          }} />
        </Box>
      )} */}
    </>
  );
};
